import PageHero from "@/components/feature/PageHero";
import Process from "./components/Process";
import Test from "./components/Test";
import ConsultCTA from "@/pages/home/components/ConsultCTA";

export default function Admission() {
  return (
    <>
      <PageHero page="admission" />
      <Process />
      <Test />
      <ConsultCTA />
    </>
  );
}